import { Base2Presenter } from "core/presenter";
import { DeviceRepository } from "core/repository";
import _ from "lodash";
import * as R from "ramda";

export default class ProductPresenter extends Base2Presenter {
  initialState() {
    return {
      loading: false,
      error: false,
      devices: [],
      devicesClone: [],
      pagination: {
        totalPage: 1,
        page: 1
      },
      currentUser: {}
    };
  }

  async onStart() {
    await this.loadDevices();
  }

  setLoading = value => {
    this.enqueue({ loading: value });
  };

  async loadDevices() {
    this.setLoading(true);
    this.renewCancelToken();

    const currentUser = await this.mRuntime.get("currentUser");

    const result = await DeviceRepository.list({
      order: [
        {
          field: "name",
          direction: "ASC"
        }
      ],
      pagination: {
        page: this.viewModel.pagination.page,
        perPage: 9
      },
      filters: []
    });

    if (result.success) {
      const totalPage = Math.ceil(
        parseInt(result.total, 10) / parseFloat(result.perPage)
      );
      const devices = _.orderBy(
        result.data,
        [device => device.name.toLowerCase()],
        ["asc"]
      );

      const devicesClone = R.clone(devices);
      devices.forEach(device => (device.disabled = true));

      this.enqueue(vm => ({
        pagination: { ...vm.pagination, totalPage },
        devices,
        currentUser,
        devicesClone
      }));
    } else if (!result.userCancelled) {
      this.enqueue({
        error: "Não foi possível carregar os dispositivos dessa empresa."
      });

      this.sendNotification({
        type: "error",
        title: "Oops",
        content: this.viewModel.error
      });
    }

    this.setLoading(false);
  }

  async onPageChange(page) {
    const actualPage = page === this.viewModel.pagination.page;
    const pageLtZero = page < 1;
    const pageGtTotal = page > this.viewModel.pagination.totalPage;
    if (actualPage || pageLtZero || pageGtTotal) {
      return;
    }

    this.enqueue(
      vm => {
        if (page < 1) {
          return { pagination: { ...vm.pagination, page: 1 } };
        } else if (page > vm.pagination.totalPage) {
          return {
            pagination: { ...vm.pagination, page: vm.pagination.totalPage }
          };
        } else {
          return { pagination: { ...vm.pagination, page } };
        }
      },
      async () => await this.loadDevices()
    );
  }

  onToggle({ name, uuid }, toggle) {
    const wordAction = {
      false: "desabilitar",
      true: "habilitar"
    };
    this.sendNotification({
      type: "confirmation",
      title: "Você tem certeza?",
      content: `Tem certeza que deseja ${wordAction[toggle]} o device ${name}?`,
      actions: [
        {
          label: "Voltar"
        },
        {
          label: `Sim, quero ${wordAction[toggle]}`,
          type: "accent",
          callback: () => this.handleToggle(uuid, toggle)
        }
      ]
    });
  }

  async handleToggle(uuid, toggle) {
    this.setLoading(true);

    let repositoryResult;

    if (!toggle) {
      repositoryResult = await DeviceRepository.delete(uuid);
    } else {
      repositoryResult = await DeviceRepository.restore(uuid);
    }

    this.handleNotifications(toggle, repositoryResult);
    this.setLoading(false);
  }

  async handleNotifications(toggle, result) {
    const wordAction = {
      false: "desabilitado",
      true: "habilitado"
    };
    const obj = {
      type: result.success ? "success" : "error",
      content: result.success
        ? `O dispositivo foi ${wordAction[toggle]}.`
        : "Ocorreu um erro na conexão. Tente novamente mais tarde."
    };

    if (result.success) {
      await this.loadDevices();
    } else {
      obj.title = "Oops...";
    }

    this.sendNotification(obj);
  }

  async onSaveConfig(index) {
    this.setLoading(true);
    const uuid = this.viewModel.devices[index]["uuid"];
    const config = this.viewModel.devices[index]["config"];

    const repositoryResult = await DeviceRepository.updateConfig(uuid, {
      ...config,
      serie: Number(config.serie),
      nfce_last_number: Number(config.nfce_last_number) || 0,
      receipt_last_number: Number(config.receipt_last_number) || 0
    });
    if (repositoryResult.success) {
      this.sendNotification({
        type: "success",
        content: "Configuração do dispositivo alterada com sucesso!"
      });
      this.viewModel.devices[index]["edit_serie"] = false;
    } else {
      this.sendNotification({
        type: "error",
        title: "Oops",
        content:
          "Não foi possível alterar a configuração do dispositivo. Por favor, certifique de não ter outro dispositivo com a mesma série."
      });
    }
    this.setLoading(false);
  }

  async onAccept(index) {
    this.setLoading(true);

    const uuid = this.viewModel.devices[index]["uuid"];
    const device = this.viewModel.devices[index]["name"];

    const repositoryResult = await DeviceRepository.updateName(uuid, device);

    if (repositoryResult.success) {
      this.sendNotification({
        type: "success",
        content: "Nome do dispositivo alterado com sucesso!"
      });
    } else {
      this.sendNotification({
        type: "error",
        title: "Oops",
        content:
          "Não foi possível alterar o nome do dispositivo. Por favor, tente novamente mais tarde ou entre em contato com o suporte."
      });
    }

    this.enqueue(vm => {
      const devices = vm.devices;
      devices[index]["disabled"] = true;

      return { devices };
    });

    this.setLoading(false);
  }

  onClose(index) {
    this.enqueue(vm => {
      const devices = vm.devices;
      const devicesClone = vm.devicesClone;

      devices[index]["disabled"] = true;
      devices[index]["name"] = devicesClone[index]["name"];

      return { devices };
    });
  }

  onChange(field, index, value) {
    this.enqueue(vm => {
      const devices = vm.devices;
      devices[index][field] = value;
      return { devices };
    });

    if (field === "edit_serie" && !value) {
      this.loadDevices();
    }
  }

  onChangeConfig(field, index, value) {
    this.enqueue(vm => {
      const devices = vm.devices;
      devices[index]["config"][field] = value;

      return { devices };
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/app/registration/device/list/presenter.js